import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const IconWithTooltip = ({ id, icon, describe, fn = () => {}, wrapperClass = "" }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div className={wrapperClass}>
      <i
        id={`TooltipTopIcon-${id}`}
        style={{ cursor: "pointer" }}
        className={icon}
        onClick={fn}
      ></i>
      {describe && (
        <Tooltip
          placement="top"
          isOpen={showTooltip}
          target={`TooltipTopIcon-${id}`}
          className="tooltip-table-dinamic"
          toggle={() => {
            setShowTooltip(!showTooltip);
          }}
        >
          {describe}
        </Tooltip>
      )}
    </div>
  );
};

export default IconWithTooltip;
